module.exports = __webpack_public_path__ + "static/media/search.410d167f.svg";